// const BASE_URL_PART_A = "https://91jgb78v3l.execute-api.us-east-1.amazonaws.com/prod/"
// const BASE_URL_PART_B = "https://sbk38t5owc.execute-api.us-east-1.amazonaws.com/prod/"
// const BASE_URL_PART_C = "https://8xm5kocfwa.execute-api.us-east-1.amazonaws.com/prod/"
// const BASE_URL_PART_D = "https://4t28ooshtf.execute-api.us-east-1.amazonaws.com/prod/"

// const BASE_URL_PART_A = "http://localhost:4000/dev/"
// const BASE_URL_PART_B = "http://localhost:5000/dev/"
// const BASE_URL_PART_C = "http://localhost:5050/dev/"
// const BASE_URL_PART_D = "http://localhost:5008/dev/"

const BASE_URL_PART_A = "https://jxhgjdi24g.execute-api.us-east-1.amazonaws.com/dev/"
const BASE_URL_PART_B = "https://pzafw14o5j.execute-api.us-east-1.amazonaws.com/dev/"
const BASE_URL_PART_C = "https://fkcx8y9pl3.execute-api.us-east-1.amazonaws.com/dev/"
const BASE_URL_PART_D = "https://ea8079z0hj.execute-api.us-east-1.amazonaws.com/dev/"
// const BASE_URL_PART_A =
//   'https://jxhgjdi24g.execute-api.us-east-1.amazonaws.com/dev/';
// const BASE_URL_PART_B =
//   'https://pzafw14o5j.execute-api.us-east-1.amazonaws.com/dev/';
// const BASE_URL_PART_C =
//   'https://fkcx8y9pl3.execute-api.us-east-1.amazonaws.com/dev/';
// const BASE_URL_PART_D =
//   'https://ea8079z0hj.execute-api.us-east-1.amazonaws.com/dev/';

//ImgUpload
const UPLOAD_URL =
  'https://8x1pz40uv9.execute-api.us-east-1.amazonaws.com/dev/uploadfile/';

export const environment = {
  //Auth

  loginUser: BASE_URL_PART_A + 'loginUser',
  forgotPassword: BASE_URL_PART_A + 'forgotPassword',
  resetPassword: BASE_URL_PART_A + 'resetPassword',
  verifyOtp: BASE_URL_PART_A + 'verifyOtp',
  getAnalytics:
    'https://zt4vunflkg.execute-api.us-east-1.amazonaws.com/prod/getAnalytics',

  //Leads
  getAiScoringGuideline: BASE_URL_PART_D + "getAiScoringGuideline",
  updateAiScoringGuideline: BASE_URL_PART_D + "updateAiScoringGuideline",
  resetAiScoringGuideline: BASE_URL_PART_D + "resetAiScoringGuideline",
  triggerLeadAiScore: BASE_URL_PART_D + "triggerLeadAiScore",
  bulkUpdateLeads: BASE_URL_PART_D + "bulkUpdateLeads",
  bulkDeleteLeads: BASE_URL_PART_D + "bulkDeleteLeads",
  bulkEmailLeads: BASE_URL_PART_D + "bulkEmailLeads",
  getAllLeads: BASE_URL_PART_A + "getAllLeads",
  createLead: BASE_URL_PART_A + "createLead",
  createBulkLead: BASE_URL_PART_A + "createBulkLead",
  getAllLeadList: BASE_URL_PART_A + "getAllLeadList",
  leadAdvanceFilter: BASE_URL_PART_A + "leadAdvanceFilter",
  getLead: BASE_URL_PART_A + "getLead",
  updateLead: BASE_URL_PART_A + "updateLead",
  createleadsfollowup: BASE_URL_PART_A + "createleadsfollowup",
  getleadsfollowup: BASE_URL_PART_A + "getleadsfollowup",
  updateleadsfollowup: BASE_URL_PART_A + "updateleadsfollowup",
  deleteleadsfollowup: BASE_URL_PART_A + "deleteleadsfollowup",
  // Pipelines
  createPipeline: BASE_URL_PART_A + "createPipeline",
  getPipelines: BASE_URL_PART_A + "getAllPipelines",
  updatePipeline: BASE_URL_PART_A + "updatePipeline",
  deletePipeline: BASE_URL_PART_A + "deletePipeline",

  // Lead Dynamic Fields
  getLeadDynamicField: BASE_URL_PART_A + "getLeadDynamicField",
  createLeadDynamicField: BASE_URL_PART_A + "createLeadDynamicField",
  updateLeadDynamicField: BASE_URL_PART_A + "updateLeadDynamicField",
  // Lead Activity Log
  getLeadActivityLog: BASE_URL_PART_A + "getLeadActivityLog",
  // Lead Communications
  createLeadCommunication: BASE_URL_PART_D + "createLeadCommunication",
  getLeadCommunications: BASE_URL_PART_D + "getLeadCommunications",
  // Lead Tasks
  createLeadTask: BASE_URL_PART_A + "createLeadTask",
  updateLeadTask: BASE_URL_PART_A + "updateLeadTask",
  getLeadTasks: BASE_URL_PART_A + "getLeadTasks",
  deleteLeadTask: BASE_URL_PART_A + "deleteLeadTask",
  scheduleMeeting: BASE_URL_PART_D + "bookAppointment",
  getAvailableTimeSlots: BASE_URL_PART_D + "getAllFreeTimeSlot",
  getLeadMeeting: BASE_URL_PART_D + "getLeadMeetings",

  // getAllLeads: BASE_URL_PART_A + 'getAllLeads',
  // createLead: BASE_URL_PART_A + 'createLead',
  // getLead: BASE_URL_PART_A + 'getLead',
  // updateLead: BASE_URL_PART_A + 'updateLead',
  // createleadsfollowup: BASE_URL_PART_A + 'createleadsfollowup',

  // Ticket Managment
  getTinaTicketHistory: BASE_URL_PART_C + 'getAllTicketHistory',
  getUsers: BASE_URL_PART_C + 'getAlluser',
  getAllTinaTicket: BASE_URL_PART_C + 'getAllTickets',
  createTicket: BASE_URL_PART_C + 'createTicket',
  updateTicket: BASE_URL_PART_C + 'updateTicket',
  updateBulkTicket: BASE_URL_PART_C + 'updateMultipleTickets',
  updateTicketHistory: BASE_URL_PART_C + 'createTicketHistory',
  createBulkTicketHistory: BASE_URL_PART_C + 'createBulkTicketHis',
  getAllZendeskTicket:
    'https://pxdoxmhdzj.execute-api.us-east-1.amazonaws.com/production/zendeskListTickets',

  //Manage Users
  getAllUsers: BASE_URL_PART_A + 'getAllUsers',
  createUser: BASE_URL_PART_A + 'createUser',
  getUser: BASE_URL_PART_A + 'getUser',
  userModuleDropdownListing: BASE_URL_PART_A + 'userModuleDropdownListing',
  getUserByDepartment: BASE_URL_PART_A + 'getUserByDepartment',
  getUserByDepartmentSchedule: BASE_URL_PART_B + 'getUserByDepartmentSchedule',
  updateUser: BASE_URL_PART_A + 'updateUser',
  getAllCenter: BASE_URL_PART_A + 'getAllCenter',
  getAllDepartment: BASE_URL_PART_A + 'getAllDepartment',
  getAllRoles: BASE_URL_PART_A + 'getAllRoles',

  //Scheduled
  createSchedule: BASE_URL_PART_A + 'createSchedule',
  getSchedule: BASE_URL_PART_A + 'getSchedule',
  getAllSchedule: BASE_URL_PART_A + 'getAllSchedule',
  bulkSchedule: BASE_URL_PART_A + 'bulkSchedule',
  deleteSchedule: BASE_URL_PART_A + 'deleteSchedule',
  updateSchedule: BASE_URL_PART_A + 'updateSchedule',

  // AI Template Generation
  generateAITemplate: BASE_URL_PART_D + 'generateAITemplate',

  // TINA AI Agent Chat
  agentChat: BASE_URL_PART_D + "agentChat",

  // pricing dashboard
  getAddOnServices:
    'https://ea8079z0hj.execute-api.us-east-1.amazonaws.com/dev/getAddOnServices',

  //Price Masters
  getAllPriceMasterWithCount: BASE_URL_PART_A + 'getAllPriceMasterWithCount',
  getAllPriceMaster: BASE_URL_PART_A + 'getAllPriceMaster',
  createPriceMaster: BASE_URL_PART_A + 'createPriceMaster',
  getPriceMaster: BASE_URL_PART_A + 'getPriceMaster',
  updatePriceMaster: BASE_URL_PART_A + 'updatePriceMaster',
  deletePriceMaster: BASE_URL_PART_A + 'deletePriceMaster',

  //Price Category
  getAllPriceCategory: BASE_URL_PART_A + 'getAllPriceCategory',

  //Appointment
  getAllAppointmentWithCount: BASE_URL_PART_A + 'getAllAppointmentWithCount',
  getAppointmentOverviewStats: BASE_URL_PART_A + 'getAppointmentOverviewStats',
  createAppointment: BASE_URL_PART_A + 'createAppointment',
  getPatient: BASE_URL_PART_A + 'getPatient',
  getAllAppointment: BASE_URL_PART_A + 'getAllAppointment',
  getAllAppointmentByPatientId:
    BASE_URL_PART_A + 'getAllAppointmentByPatientId',
  getAvailableDays: BASE_URL_PART_A + 'getAvailableDays',
  getSlots: BASE_URL_PART_A + 'getSlots',
  updateAppointment: BASE_URL_PART_A + 'updateAppointment',
  updateAppointmentData: BASE_URL_PART_A + 'updateAppointmentData',
  refundAppointmentFees: BASE_URL_PART_A + 'refundAppointmentFees',
  checkInOpdPatientData: BASE_URL_PART_B + 'checkInOpdPatientData',
  getAppointmentReport: BASE_URL_PART_A + 'getAppointmentReport',
  
  // OPD Dashboard
  saveVitals: BASE_URL_PART_D + 'saveVitals',
  saveEncounter: BASE_URL_PART_D + 'saveEncounter',
  saveSoapNote: BASE_URL_PART_D + 'saveSoapNote',
  addMedication: BASE_URL_PART_D + 'addMedication',
  getPatientJourney: BASE_URL_PART_D + 'getPatientJourney',
  getEncounter: BASE_URL_PART_D + 'getEncounter',
  getVitals: BASE_URL_PART_D + 'getVitals',
  getMedications: BASE_URL_PART_D + 'getMedications',
  getSoapNote: BASE_URL_PART_D + 'getSoapNote',

  // CPOE - Lab Orders
  addLabOrder: BASE_URL_PART_D + 'addLabOrder',
  getLabOrders: BASE_URL_PART_D + 'getLabOrders',
  updateLabOrder: BASE_URL_PART_D + 'updateLabOrder',

  // CPOE - Imaging Orders
  addImagingOrder: BASE_URL_PART_D + 'addImagingOrder',
  getImagingOrders: BASE_URL_PART_D + 'getImagingOrders',
  updateImagingOrder: BASE_URL_PART_D + 'updateImagingOrder',

  //Patient Data
  getPatientBySearch: BASE_URL_PART_A + 'getPatientBySearch',
  upload: UPLOAD_URL,
  updatePatient: BASE_URL_PART_A + 'updatePatient',
  createPatient: BASE_URL_PART_A + 'createPatient',
  createPatientsBatch: BASE_URL_PART_A + 'createPatientsBatch',
  getAllPatients: BASE_URL_PART_A + 'getAllPatients',
  getAllPatientWithCount: BASE_URL_PART_A + 'getAllPatientWithCount',
  deletePatient: BASE_URL_PART_A + 'deletePatient',

  //Billings
  createBilling: BASE_URL_PART_A + 'createBilling',
  getBillingListByPatient: BASE_URL_PART_A + 'getBillingListByPatient',
  getAllBillingDataWithCount: BASE_URL_PART_A + 'getAllBillingDataWithCount',
  getAllIpdBillingDataWithCount:
    BASE_URL_PART_B + 'getAllIpdBillingDataWithCount',
  getReceiptData: BASE_URL_PART_A + 'getReceiptData',
  generateReceiptNo: BASE_URL_PART_A + 'generateReceiptNo',
  updateBilling: BASE_URL_PART_A + 'updateBilling',
  getBillingData: BASE_URL_PART_A + 'getBillingData',
  getCreditBillingData: BASE_URL_PART_B + 'getCreditBillingData',

  //Email config
  createEmailConfig: BASE_URL_PART_A + 'createEmailConfig',
  getEmailConfig: BASE_URL_PART_A + 'getEmailConfig',
  getEmailConfigById: BASE_URL_PART_C + 'getOrgConfigById',

  updateEmailConfig: BASE_URL_PART_A + 'updateEmailConfig',

  //Templates
  getAllPrimaryCheckupTemplate:
    BASE_URL_PART_A + 'getAllPrimaryCheckupTemplate',
  updatePrimaryCheckupTemplate:
    BASE_URL_PART_A + 'updatePrimaryCheckupTemplate',

  //opdchart
  createOpdChartData: BASE_URL_PART_A + 'createOpdChartData',
  getAllOpdChartData: BASE_URL_PART_A + 'getAllOpdChartData',
  updateOpdChartData: BASE_URL_PART_A + 'updateOpdChartData',
  sharePrescription: BASE_URL_PART_B + 'sharePrescription',

  //Templates
  createMedicationTemplate: BASE_URL_PART_B + 'createMedicationTemplate',
  getMedicationTemplate: BASE_URL_PART_B + 'getMedicationTemplate',
  createInvestigationTemplate: BASE_URL_PART_B + 'createInvestigationTemplate',
  getInvestigationTemplate: BASE_URL_PART_B + 'getInvestigationTemplate',
  getAdviceTemplate: BASE_URL_PART_B + 'getAdviceTemplate',
  getDiagnosisTemplate: BASE_URL_PART_B + 'getDiagnosisTemplate',
  getMedicinesDiagnosisTemplate:
    BASE_URL_PART_B + 'getMedicinesDiagnosisTemplate',
  getAdmissionTemplate: BASE_URL_PART_B + 'getAdmissionTemplate',

  //IPD
  getAllIpdAppointmentWithCount:
    BASE_URL_PART_B + 'getAllIpdAppointmentWithCount',
  getIpdOverviewStats:
    BASE_URL_PART_B + 'getIpdOverviewStats',
  getDoctors: BASE_URL_PART_B + 'getDoctors',
  createIPDAppointment: BASE_URL_PART_B + 'createIPDAppointment',
  getPatientById: BASE_URL_PART_B + 'getPatientById',
  getIPDAppointmentDetails: BASE_URL_PART_B + 'getIPDAppointmentDetails',
  checkInIpdPatientData: BASE_URL_PART_B + 'checkInIpdPatientData',
  updateIpdAppointment: BASE_URL_PART_B + 'updateIpdAppointment',
  createIpdChartData: BASE_URL_PART_B + 'createIpdChartData',
  updateIpdChartData: BASE_URL_PART_B + 'updateIpdChartData',
  getAllIpdChartData: BASE_URL_PART_B + 'getAllIpdChartData',
  getDischargeDetails: BASE_URL_PART_B + 'getDischargeDetails',

  //IPD Billing
  getBillingModuleData: BASE_URL_PART_B + 'getBillingModuleData',
  createIPDBilling: BASE_URL_PART_B + 'createIPDBilling',
  getIPDbillsByIPDAppId: BASE_URL_PART_B + 'getIPDbillsByIPDAppId',
  updateIPDBilling: BASE_URL_PART_B + 'updateIPDBilling',
  getCreditOrganization: BASE_URL_PART_B + 'getCreditOrganization',
  generateIPDBillNo: BASE_URL_PART_B + 'generateIPDBillNo',
  getIpdBillingPrintData: BASE_URL_PART_B + 'getIpdBillingPrintData',
  getIpdBillingDataReport: BASE_URL_PART_B + 'getIpdBillingData',
  createCreditNote: BASE_URL_PART_B + 'createCreditNote',

  //Feedbacks
  getAllFeedbacksWithCount: BASE_URL_PART_B + 'getAllFeedbacksWithCount',

  //Surgery Package
  getProcedurePackageList: BASE_URL_PART_B + 'getProcedurePackageList',
  updateProcedurePackage: BASE_URL_PART_B + 'updateProcedurePackage',
  createProcedurePackage: BASE_URL_PART_B + 'createProcedurePackage',
  getProcedurePackages: BASE_URL_PART_B + 'getProcedurePackages',

  //Inventory
  getAllMedicineInventoryWithCount:
    BASE_URL_PART_B + 'getAllMedicineInventoryWithCount',
  addMedicine: BASE_URL_PART_B + 'addMedicine',
  updateMedicine: BASE_URL_PART_B + 'updateMedicine',
  deleteMedicine: BASE_URL_PART_B + 'deleteMedicine',
  getAllMedicine: BASE_URL_PART_B + 'getAllMedicine',
  getInventoryCategory: BASE_URL_PART_B + 'getInventoryCategory',
  updateStock: BASE_URL_PART_B + 'updateStock',

  //Supply
  getAllSupplyWithCount: BASE_URL_PART_B + 'getAllSupplyWithCount',
  addSupply: BASE_URL_PART_B + 'addSupply',
  updateSupply: BASE_URL_PART_B + 'updateSupply',
  deleteSupply: BASE_URL_PART_B + 'deleteSupply',
  getAllSupply: BASE_URL_PART_B + 'getAllSupply',

  getTaxes: BASE_URL_PART_B + 'getTaxes',
  createTaxes: BASE_URL_PART_B + 'createTaxes',
  updateTaxes: BASE_URL_PART_B + 'updateTaxes',
  deleteTaxes: BASE_URL_PART_B + 'deleteTaxes',

  getPaymentMethods: BASE_URL_PART_B + 'getPaymentMethods',
  createPaymentMethods: BASE_URL_PART_B + 'createPaymentMethods',
  updatePaymentMethods: BASE_URL_PART_B + 'updatePaymentMethods',
  deletePaymentMethods: BASE_URL_PART_B + 'deletePaymentMethods',

  //Import Database
  importAppointments: BASE_URL_PART_B + 'importAppointments',

  // Campaign Modules
  createSubscriberList: BASE_URL_PART_D + 'createSubscriberList',
  getAllSubscriberList: BASE_URL_PART_D + 'getAllSubscriberList',
  deleteSubscriberList: BASE_URL_PART_D + 'deleteSubscriberList',
  getSubsciberList: BASE_URL_PART_D + 'getSubscriberlist',
  addCampaignList: BASE_URL_PART_D + 'addCampaignList',
  updateCampaignList: BASE_URL_PART_D + 'updateCampaignList',
  getAllCampaignList: BASE_URL_PART_D + 'getAllCampaignList',
  deleteCampaignList: BASE_URL_PART_D + 'deleteCampaignList',
  createCampaignList: BASE_URL_PART_D + 'createCampaignList',
  getAllSubsciberList: BASE_URL_PART_D + 'getAllSubscriberList',
  deleteSubsciberList: BASE_URL_PART_D + 'deleteSubsciberList',
  getAllCampaignWithCount: BASE_URL_PART_D + 'getAllCampaignWithCount',
  runCampaignWhatsapp: BASE_URL_PART_D + 'runCampaignWhatsapp',
  runCampaignEmail: BASE_URL_PART_D + 'runCampaignEmail',
  runCampaignTextMessage: BASE_URL_PART_D + 'runCampaignTextMessage',
  //Analytics
  getLeadAnalytics: BASE_URL_PART_D + 'getLeadAnalytics',
  getAppointmentAnalytics: BASE_URL_PART_D + 'getAppointmentAnalytics',
  // Campaign Modules (old, kept for compatibility)
  getAMCStatus: BASE_URL_PART_D + 'getAMCStatus',
  //advance deposits
  createAdvanceDeposit: BASE_URL_PART_A + 'createAdvanceDeposit',
  getAdvanceDeposit: BASE_URL_PART_A + 'getAdvanceDeposit',
  updateAdvanceDeposit: BASE_URL_PART_A + 'updateAdvanceDeposit',
  deleteAdvanceDeposit: BASE_URL_PART_A + 'deleteAdvanceDeposit',

  //template
  getAllTemplates:
    'https://ekofx0jipf.execute-api.us-east-1.amazonaws.com/prod/getAllTemplates',
  //msg
  sendWhatsappMsg:
    'https://ekofx0jipf.execute-api.us-east-1.amazonaws.com/prod/sendWhatsappMsg',
  sendMediaTemplateMsg:
    'https://ekofx0jipf.execute-api.us-east-1.amazonaws.com/prod/sendMediaTemplateMsg',

  createCoupon: BASE_URL_PART_B + 'createCoupon',
  getAllCouponWithCount: BASE_URL_PART_B + 'getAllCouponWithCount',
  getCoupon: BASE_URL_PART_B + 'getCoupon',
  updateCoupon: BASE_URL_PART_B + 'updateCoupon',
  deleteCoupon: BASE_URL_PART_B + 'deleteCoupon',

  //Packages
  getPackages: BASE_URL_PART_D + 'getPackages',

  // ===== CRM MODULES: Contact Groups, WhatsApp Templates, Email Templates, Sales Mail Hub, Broadcast Campaign =====

  // Contact Groups
  getAllContactGroups: BASE_URL_PART_D + 'getAllContact_group',
  createContactGroup: BASE_URL_PART_D + 'createContact_group',
  getLeadAndContactId: BASE_URL_PART_D + 'getLeadAndContactId',
  updateContactGroup: BASE_URL_PART_D + 'updateContact_group',
  deleteContactGroup: BASE_URL_PART_D + 'deleteContact_group',
  addContactToGroupList: BASE_URL_PART_C + 'createContactGroupList',
  getAllContactWithCount: BASE_URL_PART_D + 'getAllContactWithCount',
  getLeadsRocord: BASE_URL_PART_D + 'getLeadRecord',

  // WhatsApp Template
  getAllWhatsappTemplates: BASE_URL_PART_D + 'getAllTemplateWithPagination',
  getAppId: BASE_URL_PART_D + 'getWhatsappConfig',
  createWhatsappTemplate: BASE_URL_PART_D + 'createWhatsappTemplate',
  getAllLanguages: BASE_URL_PART_D + 'getAllLanguage',
  updateWhatsappTemplate: BASE_URL_PART_D + 'updateGupshupTemplate',
  deleteWhatsappTemplate: BASE_URL_PART_D + 'deleteTemplateByTemplateId',
  refreshGupshupTemplates: BASE_URL_PART_D + 'bulkUpdateWhasappTemplateStatus',
  getAllWhatsappTemplatesGupshup: BASE_URL_PART_D + 'getGupshupTemplate',
  getGupshuTemplateById: BASE_URL_PART_D + 'getGupshupTemplateById',
  getAllTemplatesWithStatusFilter:
    BASE_URL_PART_D + 'getAllTemplatesWithStatusFilter',
  getWhatsappConfig: BASE_URL_PART_D + 'getWhatsappConfig',
  uploadGupshupMedia:
    'https://okxvsyvxq1.execute-api.us-east-1.amazonaws.com/prod/uploadMedia',

  // manage campaign section (Broadcast Campaign)
  getAllManangeCampaign: BASE_URL_PART_D + 'getAllCampaign',
  createCampaign: BASE_URL_PART_D + 'createCampaign',
  // runCampaign: BASE_URL_PART_D+"campaignBroadcast",
  runCampaign: BASE_URL_PART_D + 'testCampaignBroadcast',
  deleteCampaign: BASE_URL_PART_D + 'deleteCampaign',
  updateCampaign: BASE_URL_PART_D + 'updateCampaign',
  testCampaignEmail: BASE_URL_PART_D + 'testCampaignEmail',

  // Campaign Tracking
  getCampaignTracking: BASE_URL_PART_C + 'getCampaignTracking',
  getWhatsappCampaignTracking: BASE_URL_PART_D + 'getWhatsappCampaignTracking',
  getReputation: BASE_URL_PART_D + 'getReputation',

  // Email Campaign Details
  createEmailCampaignDetails: BASE_URL_PART_C + 'createEmailCampaignDetails',
  getAllEmailCampaignDetails: BASE_URL_PART_C + 'getAllEmailCampaignDetails',
  getEmailCampaignDetails: BASE_URL_PART_C + 'getEmailCampaignDetails',
  updateEmailCampaignDetails: BASE_URL_PART_C + 'updateEmailCampaignDetails',
  deleteEmailCampaignDetails: BASE_URL_PART_C + 'deleteEmailCampaignDetails',

  // Email Campaign Overflow Queue
  createEmailOverflowQueue: BASE_URL_PART_C + 'createEmailOverflowQueue',
  getAllEmailOverflowQueue: BASE_URL_PART_C + 'getAllEmailOverflowQueue',
  getEmailOverflowQueue: BASE_URL_PART_C + 'getEmailOverflowQueue',
  updateEmailOverflowQueue: BASE_URL_PART_C + 'updateEmailOverflowQueue',
  deleteEmailOverflowQueue: BASE_URL_PART_C + 'deleteEmailOverflowQueue',

  // Email Provider Config
  createEmailProviderConfig: BASE_URL_PART_C + 'createEmailProviderConfig',
  getAllEmailProviderConfig: BASE_URL_PART_C + 'getAllEmailProviderConfig',
  getEmailProviderConfig: BASE_URL_PART_C + 'getEmailProviderConfig',
  updateEmailProviderConfig: BASE_URL_PART_C + 'updateEmailProviderConfig',
  deleteEmailProviderConfig: BASE_URL_PART_C + 'deleteEmailProviderConfig',

  // Email Reputation
  createEmailReputation: BASE_URL_PART_C + 'createEmailReputation',
  getAllEmailReputation: BASE_URL_PART_C + 'getAllEmailReputation',
  getEmailReputation: BASE_URL_PART_C + 'getEmailReputation',
  updateEmailReputation: BASE_URL_PART_C + 'updateEmailReputation',
  deleteEmailReputation: BASE_URL_PART_C + 'deleteEmailReputation',

  // Google Token
  createGoogleToken: BASE_URL_PART_C + 'createGoogleToken',
  getAllGoogleToken: BASE_URL_PART_C + 'getAllGoogleToken',
  getGoogleToken: BASE_URL_PART_C + 'getGoogleToken',
  updateGoogleToken: BASE_URL_PART_C + 'updateGoogleToken',
  deleteGoogleToken: BASE_URL_PART_C + 'deleteGoogleToken',

  // OAuth Token
  createOauthToken: BASE_URL_PART_C + 'createOauthToken',
  getAllOauthToken: BASE_URL_PART_C + 'getAllOauthToken',
  getOauthToken: BASE_URL_PART_C + 'getOauthToken',
  updateOauthToken: BASE_URL_PART_C + 'updateOauthToken',
  deleteOauthToken: BASE_URL_PART_C + 'deleteOauthToken',

  // OAuth Gmail Token
  createOauthGmailToken: BASE_URL_PART_C + 'createOauthGmailToken',
  getAllOauthGmailToken: BASE_URL_PART_C + 'getAllOauthGmailToken',
  getOauthGmailToken: BASE_URL_PART_C + 'getOauthGmailToken',
  updateOauthGmailToken: BASE_URL_PART_C + 'updateOauthGmailToken',
  deleteOauthGmailToken: BASE_URL_PART_C + 'deleteOauthGmailToken',

  // WhatsApp Campaign Tracking
  createWhatsappCampaignTracking:
    BASE_URL_PART_C + 'createWhatsappCampaignTracking',
  getAllWhatsappCampaignTracking:
    BASE_URL_PART_C + 'getAllWhatsappCampaignTracking',
  getWhatsappCampaignTrackingById:
    BASE_URL_PART_C + 'getWhatsappCampaignTrackingById',
  updateWhatsappCampaignTracking:
    BASE_URL_PART_C + 'updateWhatsappCampaignTracking',
  deleteWhatsappCampaignTracking:
    BASE_URL_PART_C + 'deleteWhatsappCampaignTracking',

  // Client Configuration
  getAllClientConfig: BASE_URL_PART_C + 'getAllOrgConfig',
  createClientConfig: BASE_URL_PART_C + 'createOrgConfig',
  updateClientConfig: BASE_URL_PART_C + 'updateOrgConfig',
  deleteClientConfig: BASE_URL_PART_C + 'deleteOrgConfig',
  getActiveDirectoryConfigByClientId:
    BASE_URL_PART_C + 'getActiveDirectoryConfigByClientId',
  createActiveDirectoryConfig: BASE_URL_PART_C + 'createActiveDirectoryConfig',
  updateActiveDirectoryConfig: BASE_URL_PART_C + 'updateActiveDirectoryConfig',

  // Contact Group List
  createContactGroupList: BASE_URL_PART_C + 'createContactGroupList',
  getAllContactGroupList: BASE_URL_PART_C + 'getAllContactGroupList',
  getContactGroupList: BASE_URL_PART_C + 'getContactGroupList',
  updateContactGroupList: BASE_URL_PART_C + 'updateContactGroupList',
  deleteContactGroupList: BASE_URL_PART_C + 'deleteContactGroupList',

  // Organization Config
  createOrgConfig: BASE_URL_PART_C + 'createOrgConfig',
  updateOrgConfig: BASE_URL_PART_C + 'updateOrgConfig',
  getAllOrgConfig: BASE_URL_PART_C + 'getAllOrgConfig',
  getOrgConfigById: BASE_URL_PART_C + 'getOrgConfigById',
  deleteOrgConfig: BASE_URL_PART_C + 'deleteOrgConfig',

  // Email Templates
  createEmailTemplate: BASE_URL_PART_C + 'createEmailTemplate',
  getAllEmailTemplate: BASE_URL_PART_C + 'getAllEmailTemplate',
  getEmailTemplate: BASE_URL_PART_C + 'getEmailTemplate',
  updateEmailTemplate: BASE_URL_PART_C + 'updateEmailTemplate',
  getEmailTemplateById: BASE_URL_PART_C + 'getEmailTemplateById',
  deleteEmailTemplate: BASE_URL_PART_C + 'deleteEmailTemplate',

  // AWS SES Provider
  authenticateClientDomain: BASE_URL_PART_C + 'authenticateClientDomain',
  domainVeriicationStatus: BASE_URL_PART_C + 'domainVeriicationStatus',
  verifyDomainEmail: BASE_URL_PART_C + 'verifyDomainEmail',
  deleteDomainAndEmail: BASE_URL_PART_C + 'deleteDomainAndEmail',

  // Hospital Domain
  getAllHospitalDomain: BASE_URL_PART_C + 'getAllHospitalDomain',
  updateHospitalDomain: BASE_URL_PART_C + 'updateHospitalDomain',
  updateClientDomain: BASE_URL_PART_C + 'updateHospitalDomain',
  getAllClientDomain: BASE_URL_PART_C + 'getAllHospitalDomain',

  // Outlook SSO
  getOutlookToken: BASE_URL_PART_C + 'getOutlookToken',
  getCodeForOutlookToken: BASE_URL_PART_C + 'getCodeForOutlookToken',
  disconnectOutlook: BASE_URL_PART_C + 'disconnectOutlook',
  revokeAccess: BASE_URL_PART_C + 'disconnectOutlook',
  getConnectedOutlookEmail: BASE_URL_PART_C + 'getConnectedOutlookEmail',

  // Google SSO
  googleOAuthCallback: BASE_URL_PART_C + 'googleOAuthCallback',
  getCodeForGoogleToken: BASE_URL_PART_C + 'getCodeForGoogleToken',
  disconnectGmail: BASE_URL_PART_C + 'disconnectGmail',
  getConnectedGmailAccounts: BASE_URL_PART_C + 'getConnectedGmailAccounts',
  getConnectedGmailEmail: BASE_URL_PART_C + 'getConnectedGmailEmail',

  // Outlook Mail Hub
  outlookInboxEmail: BASE_URL_PART_C + 'outlookInboxEmail',
  outlookSentEmail: BASE_URL_PART_C + 'outlookSentEmail',
  outlookDraftEmail: BASE_URL_PART_C + 'outlookDraftEmail',
  outlookJunkEmail: BASE_URL_PART_C + 'outlookJunkEmail',
  deleteOutlookEmail: BASE_URL_PART_C + 'deleteOutlookEmail',
  deleteOutlookEmailPermanently:
    BASE_URL_PART_C + 'deleteOutlookEmailPermanently',
  outlookDeletedEmail: BASE_URL_PART_C + 'outlookDeletedEmail',
  sendEmailUsingOutlook: BASE_URL_PART_C + 'sendEmailUsingOutlook',
  getOutlookEmailWithAttachment:
    BASE_URL_PART_C + 'getOutlookEmailWithAttachment',
  createOutlookDraftEmail: BASE_URL_PART_C + 'createOutlookDraftEmail',
  updateOutlookDraftEmail: BASE_URL_PART_C + 'updateOutlookDraftEmail',
  sendOutlookDraftEmail: BASE_URL_PART_C + 'sendOutlookDraftEmail',
  deleteOutlookDraftEmailAttachment:
    BASE_URL_PART_C + 'deleteOutlookDraftEmailAttachment',
  createOutlookReplyDraft: BASE_URL_PART_C + 'createOutlookReplyDraft',
  createOutlookReplyAllDraft: BASE_URL_PART_C + 'createOutlookReplyAllDraft',
  sendOutlookReplyEmail: BASE_URL_PART_C + 'sendOutlookReplyEmail',
  forwardOutlookEmail: BASE_URL_PART_C + 'forwardOutlookEmail',
  addOutlookAttachmentInReply: BASE_URL_PART_C + 'addOutlookAttachmentInReply',
  deleteOutlookAttachmentFromEmail:
    BASE_URL_PART_C + 'deleteOutlookAttachmentFromEmail',
  getOutlookEmailAttachments: BASE_URL_PART_C + 'getOutlookEmailAttachments',
  createOutlookReply: BASE_URL_PART_C + 'createOutlookReply',
  sendOutlookReply: BASE_URL_PART_C + 'sendOutlookReply',
  createOutlookReplyAll: BASE_URL_PART_C + 'createOutlookReplyAll',
  addAttachmentInOutlookReply: BASE_URL_PART_C + 'addAttachmentInOutlookReply',
  deleteAttachmentInOutlook: BASE_URL_PART_C + 'deleteAttachmentInOutlook',

  // Gmail Mail Hub
  gmailInboxEmail: BASE_URL_PART_C + 'gmailInboxEmail',
  gmailSentEmail: BASE_URL_PART_C + 'gmailSentEmail',
  gmailDraftEmail: BASE_URL_PART_C + 'gmailDraftEmail',
  gmailSpamEmail: BASE_URL_PART_C + 'gmailSpamEmail',
  gmailTrashEmail: BASE_URL_PART_C + 'gmailTrashEmail',
  sendEmailUsingGmail: BASE_URL_PART_C + 'sendEmailUsingGmail',
  deleteGmailEmail: BASE_URL_PART_C + 'deleteGmailEmail',
  deleteGmailEmailPermanently: BASE_URL_PART_C + 'deleteGmailEmailPermanently',
  getGmailEmailWithAttachment: BASE_URL_PART_C + 'getGmailEmailWithAttachment',
  createGmailDraftEmail: BASE_URL_PART_C + 'createGmailDraftEmail',
  updateGmailDraftEmail: BASE_URL_PART_C + 'updateGmailDraftEmail',
  sendGmailDraftEmail: BASE_URL_PART_C + 'sendGmailDraftEmail',
  deleteGmailDraftEmail: BASE_URL_PART_C + 'deleteGmailDraftEmail',
  createGmailReplyDraft: BASE_URL_PART_C + 'createGmailReplyDraft',
  createGmailReplyAllDraft: BASE_URL_PART_C + 'createGmailReplyAllDraft',
  sendGmailReplyEmail: BASE_URL_PART_C + 'sendGmailReplyEmail',
  forwardGmailEmail: BASE_URL_PART_C + 'forwardGmailEmail',
  getGmailEmailAttachments: BASE_URL_PART_C + 'getGmailEmailAttachments',

  // =========================================
  // BASE API
  // =========================================
  OCR_BASE_URL:
    'https://vsfzaklngguu7ku3kxocjrsu3q0nqnvf.lambda-url.us-east-1.on.aws',

  // =========================================
  // HEALTH CHECK
  // =========================================
  HEALTH_API: '/health',

  // =========================================
  // OCR MODULE APIs
  // =========================================

  /**
   * ID Card OCR
   * Aadhaar / PAN / Insurance Card
   */
  OCR_EXTRACT_ID_CARD_API: '/extract',

  /**
   * Prescription OCR
   */
  OCR_PRESCRIPTION_API: '/prescription',

  /**
   * Lab Report OCR
   */
  OCR_LAB_REPORT_API: '/lab',

  /**
   * Discharge Summary OCR
   */
  OCR_DISCHARGE_SUMMARY_API: '/discharge',

  /**
   * Pre Surgery Form OCR
   */
  OCR_PRE_SURGERY_API: '/presurgery',

  /**
   * Insurance / EOB OCR
   */
  OCR_INSURANCE_API: '/insurance',

  // =========================================
  // DOCUMENT CHAT / RAG APIs
  // =========================================

  /**
   * Store Document
   */
  DOCUMENT_STORE_API: '/store-doc',

  /**
   * Chat with Document
   */
  DOCUMENT_CHAT_API: '/chat',

  /**
   * Clear Session
   */
  DOCUMENT_CLEAR_SESSION_API: '/clear-chat',

  // =========================================
  // FILE CONFIGURATION
  // =========================================
  MAX_FILE_SIZE_MB: 20,

  SUPPORTED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],

  SUPPORTED_DOCUMENT_TYPES: [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/webp',
  ],

  // =========================================
  // OCR CONFIG
  // =========================================
  OCR_TIMEOUT: 120000,

  OCR_RETRY_COUNT: 2,

  // =========================================
  // CHAT CONFIG
  // =========================================
  CHAT_STREAM_DELAY: 30,

  CHAT_MAX_HISTORY: 100,

  // =========================================
  // FEATURE FLAGS
  // =========================================
  ENABLE_DOCUMENT_CHAT: true,
  ENABLE_PDF_PREVIEW: true,
  ENABLE_CAMERA_CAPTURE: true,
  ENABLE_MULTI_UPLOAD: true,
  prescription_ocr_api_key: '7J42kCnQ9Y7czrwOVaL5rsHmA7aMszDGwa8xPKXI',
  htr_recognize_url:
    'https://741zcj7vy6.execute-api.us-east-1.amazonaws.com/htr/recognize',

  // Dynamic Form Builder
  createDynamicForm: BASE_URL_PART_C + 'createDynamicForm',
  updateDynamicForm: BASE_URL_PART_C + 'updateDynamicForm',
  getDynamicFormByToken: BASE_URL_PART_C + 'getDynamicFormByToken',
  deleteDynamicForm: BASE_URL_PART_C + 'deleteDynamicForm',
  submitPublicForm: BASE_URL_PART_C + 'addFormData',
  getDynamicFormList: BASE_URL_PART_C + 'getAllDynamicForms'
};
